var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Button',{staticClass:"buttoncolor",staticStyle:{"width":"90px"},attrs:{"icon":_vm.icon},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.label)+" ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }